module.exports =  {
	title:'隐私协议',
	
	text:`
	重要须知：
	<br/><br/>《游斐用户个人信息及隐私保护政策》（以下简称“《隐私政策》”）由您（以下亦称“用户”或“您”）与上海游斐网络科技有限公司 （下文亦称“游斐”或“我们”）共同缔结，本《隐私政策》具有合同效力。
	欢迎您使用游斐为您提供的服务，包括但不限于您与游斐的交互行为及/或您注册和使用游斐游戏及/或注册和使用游斐提供的产品或服务（以下统称“游斐服务” 或“服务”）；游斐为保障用户在使用游斐服务期间的隐私权，游斐特此制定本《游斐用户个人信息及隐私保护政策》，用以向您说明在使用游斐服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。
	 本《隐私政策》适用于我们为您提供的游斐的服务。当您使用我们提供的产品或服务时，我们将按照本政策的约定处理和保护您的个人信息。
	若您是未满18周岁的未成年人（特别是未满十四周岁的儿童），游斐特别提请您注意，您需要在您的监护人的陪同下阅读本《隐私政策》，我们已使用红色字体或黑色加粗字体标注未成年人（特别是未满十四周岁的儿童）个人信息的相关的条款，请您和您的监护人务必仔细阅读；请您在取得您的监护人对本《隐私政策》全部条款的同意之后使用游斐提供的各项产品和服务。
	监护人特别说明：
	若我们获悉您监护的未成年人不满十四周岁，我们将根据本《隐私政策》采取特殊措施保护我们获得的您监护的未成年人的个人信息。请帮助我们保护您监护的未成年人的个人信息和隐私安全，要求他们在您的监护下共同阅读并接受本《隐私政策》，且应在您的同意和指导下提交个人信息、使用游斐服务。如果您不同意本《隐私政策》的内容，您应要求您监护的未成年人立即停止访问/使用游斐服务。若您点击同意本《隐私政策》，或者您监护的未成年人使用/继续使用我们的服务，即表示您和您监护的未成年人同意受本《隐私政策》的约束。
	儿童特别说明：
	我们建议：任何儿童参加网上活动都应事先取得监护人的同意。如果您是儿童，请通知您的监护人共同阅读本《隐私政策》，并在您提交个人信息、使用游斐服务之前，寻求并取得您的监护人的同意和指导。您点击同意本《隐私政策》，或者您使用/继续使用游斐服务、提交个人信息，都表示您已获得您的监护人的许可，且您的监护人亦同意受本《隐私政策》的约束。
	请您注意我们可能会不时地检查、更新《隐私政策》，因此有关的措施会随之变化；我们可能随时修改本《隐私政策》的条款，该等修改构成本《隐私政策》的一部分。请您随时关注我们的官方页面以确保对我们隐私政策最新版本始终保持了解。如您认为该等修改造成您在本《隐私政策》下权利的实质减少，您可以选择停止使用我们向您提供的服务；在该种情况下，若您仍然继续使用我们的服务的，即表示您同意受经修订的本《隐私政策》的约束。
	在阅读完本《隐私政策》之后，如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，可通过游斐官方公布的客服联系方式与我们联系。
	<br/><br/>一、游斐可能收集的信息： 
	<br/><br/>我们向您提供服务时，可能会收集、储存或以其他合法方式使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的部分或全部产品或服务，或者无法达到相关服务拟达到的效果。
	<br/><br/>1.1您在使用我们产品或服务时主动提供的信息包括但不限于：
	<br/><br/>1.1.1 您在注册账户或使用我们的产品或服务时，向我们提供的相关个人信息，例如电话号码、电子邮件、昵称；
	<br/><br/>1.1.2 您通过我们的产品或服务向其他方提供的共享信息，以及您使用我们的产品或服务时所储存的信息。
	<br/><br/>1.2我们在您使用产品或服务时可能获取的您的信息 ：
	<br/><br/>1.2.1日志信息，指您使用我们的产品或服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括但不限于：
	<br/><br/>1.2.1.1设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们产品或服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
	<br/><br/>1.2.1.2在使用我们产品或服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们产品或服务时浏览或要求提供的其他信息和内容详情；
	<br/><br/>1.2.1.3有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；
	<br/><br/>1.2.1.4您通过我们的产品或服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；
	<br/><br/>1.2.1.5您通过我们的产品或服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点；
	<br/><br/>1.2.2位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；
	<br/><br/>1.2.3您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；您可以通过关闭定位功能，停止对您的地理位置信息的收集。
	<br/><br/>1.3其他用户使用我们的产品或服务时所提供及/或分享的信息中含有的您的信息。
	<br/><br/>二、游斐如何使用您的信息 
	<br/><br/>2.1帮助您完成注册。为便于我们为您提供服务，您需要提供基本注册信息，例如手机号码、电子邮箱地址，并创建您的用户名和密码。在使用部分产品或服务中，如果您仅需使用浏览、搜索等基本服务，您不需要注册成为游斐用户及提供上述信息。
	<br/><br/>2.2向您提供产品或服务。我们收集和使用信息是为了向您提供游斐的产品或服务。
	<br/><br/>2.2.1在我们提供产品或服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
	<br/><br/>2.2.2帮助我们设计新产品或服务，改善我们现有产品或服务；
	<br/><br/>2.2.3使我们更加了解您如何接入和使用我们的产品或服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他使用我们服务的用户做出其他方面的回应；
	<br/><br/>2.2.4向您提供与您更加相关的广告以替代普遍投放的广告；
	<br/><br/>2.2.5评估我们产品或服务中的广告和其他促销及推广活动的效果，并加以改善；
	<br/><br/>2.2.6软件认证或管理软件升级；
	<br/><br/>2.2.7让您参与有关我们产品和服务的调查。 
	<br/><br/>2.3向您推送消息。
	<br/><br/>2.3.1为您展示和推送产品或服务。我们可能使用您的信息，您的浏览及搜索记录、设备信息、位置信息、订单信息，提取您的浏览、搜索偏好、行为习惯、位置信息等特征，并基于特征标签通过电子邮件、短信、电话或其他方式向您发送营销信息，提供或推广我们的产品或服务。
	<br/><br/>2.3.2向您发出通知。我们可能在必需时（例如当我们由于系统维护而暂停提供服务、变更、终止提供单项服务时）向您发出与服务有关的通知。
	<br/><br/>2.4改进我们的产品或服务。为了让您有更好的体验、改善我们的产品或服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过我们的某一项产品或服务所收集的个人信息，以汇集信息或者个性化的方式，用于我们的其他产品或服务。
	<br/><br/>2.4.1您使用我们的一项产品或服务时所被收集的您的个人信息，可能在我们的另一产品或服务中用于向您提供特定内容或向您展示与您相关的、而非普遍推送的信息。
	<br/><br/>2.4.2我们可能让您参与有游斐产品或服务的调查，帮助我们改善现有服务或设计新服务；同时，我们可能将您的信息用于软件更新。
	<br/><br/>2.4.3在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别您的身份，在此情况下我们可能会使用已经去标识化的信息，对用户数据库进行分析并予以商业化的利用。
	<br/><br/>如果我们将您的信息用于本《隐私政策》中未载明的其他用途，会事先征求您同意。
	<br/><br/>此外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息而无需事先征得您的授权同意：
	<br/><br/>（1）与国家安全、国防安全直接相关的；
	<br/><br/>（2）与公共安全、公共卫生、重大公共利益直接相关的；
	<br/><br/>（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
	<br/><br/>（4）出于维护作为个人信息主体的用户或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
	<br/><br/>（5）所收集的个人信息是作为个人信息主体的用户自行向社会公众公开的；
	<br/><br/>（6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；
	<br/><br/>（7）根据作为个人信息主体的用户要求签订和履行合同所必需的；
	<br/><br/>（8）用于维护游斐提供的游斐服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；及/或
	<br/><br/>（9）法律法规规定的其他情形。
	<br/><br/>三、游斐如何分享、转让或披露您的个人信息
	<br/><br/>我们将尽量采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用我们的产品或服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，我们可能会要求您进行身份验证，以保障您的账户安全。
	<br/><br/>3.1我们如何分享您的信息 
	<br/><br/>我们遵照法律法规的规定，对信息的分享进行严格限制。除以下情形外，未经您同意，我们不会与游斐之外的任何第三方分享您的信息：
	<br/><br/>3.1.1向您提供我们的产品或服务，我们可能向合作伙伴及其他第三方分享您的信息，以实现您需要的核心功能或提供您需要的服务，例如：向物流服务商提供对应的订单信息；向通讯服务提供商提供对应的联系信息；
	<br/><br/>3.1.2维护和改善我们的产品或服务。我们可能向合作伙伴及其他第三方分享您的信息，以帮助我们为您提供更有针对性、更完善的服务，例如：向物流服务商提供对应的订单信息；向通讯服务提供商提供对应的联系信息；
	<br/><br/>3.1.3实现本《隐私政策》第二条“游斐如何使用您的信息”部分所述目的；
	<br/><br/>3.1.4履行我们在本《隐私政策》或我们与您达成的其他协议中的义务和行使我们的权利；
	<br/><br/>3.1.5向委托我们进行推广的合作伙伴等第三方共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供可以识别您身份的信息，或者我们将这些信息进行汇总，以便它不会识别您个人；
	<br/><br/>3.1.6基于国家法律法规的规定而提供您的信息；
	<br/><br/>3.1.7基于国家司法机关及其他有关机关基于法定程序的要求而提供您的信息；
	<br/><br/>3.1.8基于用户本人或用户监护人的合法要求；
	<br/><br/>3.1.9为保护游斐或您的合法权益且符合法律法规的适当的披露；
	<br/><br/>3.1.10在紧急情况下，基于符合法律法规为保护其他用户及第三方人身安全而提供您的信息；
	<br/><br/>3.1.11为维护社会公众的利益而提供您的信息；及/或
	<br/><br/>3.1.12根据与您签署的单项服务协议或其他的法律文件约定所提供您的信息。
	<br/><br/>我们仅会出于合法、正当、必要、特定、明确的目的共享您的信息。如我们与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守法律法规、本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。
	<br/><br/>有关分享信息的提示
	<br/><br/>我们的多项服务可让您不仅与您的网络游戏、也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您的照片）、您对其他人上传或发布的信息做出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是我们的社交媒体服务，是专为使您可以与世界各地的用户共享信息而设计，从而使共享信息可实时、广泛的传递。只要您不删除共享信息，有关信息便一直留存在公众领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。
	<br/><br/>因此，请您认真考虑您通过我们的产品或服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您的共享信息的用户范围。     
	<br/><br/>游斐的用户可以选择是否披露信息。有些信息是登记我们的服务所必需的，但大多数其他信息的提供是由您自由决定的。游斐将视用户舒适度及自主选择为首位。
	<br/><br/>游斐为用户提供丰富的网络互动活动，为便于您参与互动活动并获取互动奖品，游斐通常要求您在联系方法(通讯地址和电话)之外，还要根据其个人兴趣填写表格。此类信息被游斐用来累积其用户的数据。是否提供所要求的信息和参加此类活动，这完全由您自行决定。
	<br/><br/>3.2 我们如何转让您的信息 
	<br/><br/>随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本《隐私政策》的约束并继续保护您的个人信息，否则,我们将要求该公司、组织重新向您征求授权同意。
	<br/><br/>3.3 我们如何披露您的信息 
	<br/><br/>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，披露您的信息：
	<br/><br/>根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您的信息的情况下，我们可能会依据所要求的信息类型和披露方式披露您的信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
	<br/><br/>3.4、我们如何保留、储存和保护您的信息 
	<br/><br/>我们仅在本《隐私政策》所述目的所必需期间和法律法规要求的时限内保留您的个人信息。我们将采取以下手段保护您的信息：
	<br/><br/>3.4.1 数据安全技术措施。我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您向我们提供的个人信息。但请您谅解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。希望您能理解，您接入及/或使用我们的产品或服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。
	<br/><br/>3.4.2 我们为保护您的个人信息采取的其他安全措施。我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用；我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制；通过加强安全意识，加强员工对于保护信息重要性的认识；我们仅允许有必要知晓这些信息的游斐公司员工、合作伙伴访问您的信息，并为此设置了严格的访问权限控制和监控机制；我们同时要求可能接触到您的信息的所有人员履行相应的保密义务。我们将努力确保前述人员在接触您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施，如果未能履行这些义务，前述人员可能会被追究法律责任或被终止与游斐的合作关系；我们会采取一切合理可行的措施，确保不收集无关的信息。
	<br/><br/>互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，我们建议您使用此类工具时请使用复杂密码，并注意保护您的信息安全。
	<br/><br/>互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将在中国法律法规规定的范围内承担相应的法律责任。本《隐私政策》仅适用于我们所收集的用户的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，对任何第三方使用由您提供的信息导致您的合法权益受损，我们并不承担任何责任。
	<br/><br/>3.4.3 信息存储的方式和期限
	<br/><br/>我们保证我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。未获得您的明示授权、法律法规的明确规定；及/或相关主管机构的要求，我们不会将您的个人信息转移出境。我们保证只会在为实现服务目的所必需的时间内或法律法规规定的条件及期限下存储您的个人信息。
	<br/><br/>四、如何管理您的信息
	<br/><br/>4.1 访问、更新、删除和改变您授权同意的范围
	<br/><br/>我们鼓励您更新和修改您的信息以使其更准确有效。您能通过游斐通行证账号系统访问您的信息，并根据对应信息的管理方式自行完成或要求我们进行修改、补充和删除。我们将采取适当的技术手段，尽可能保证您可以访问、更新和更正自己的信息或使用游斐服务时提供的其他信息。
	<br/><br/>在访问、更新、更正、修改或删除前述信息时，我们可能会要求您进行身份验证，以保障信息安全。您可以通过本《隐私政策》约定的联系方式对部分个人信息改变或撤销您的授权，改变或撤销的部分个人信息系非使用产品或服务必备的您的个人信息。
	<br/><br/>请您理解，由于技术所限、法律或监管要求，我们可能无法满足您的所有要求，我们会在合理的期限内答复您的请求。
	<br/><br/>4.2注销
	<br/><br/>在符合游斐单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项游斐服务帐号可能被注销或删除。当帐号注销或被删除后，与该帐号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或处理。
	<br/><br/>4.3 有关敏感个人信息的提示
	<br/><br/>某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息，以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹信息。
	<br/><br/>请注意，您在游斐服务中所提供、上传或发布的内容和信息（例如有关您社交活动的照片或信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否使用我们的服务披露您的敏感个人信息。
	<br/><br/>接受或使用游斐的服务视为您同意您的敏感个人信息按本《隐私政策》所述的目的和方式来处理。
	<br/><br/>五、COOKIES、日志档案和WEB BEACON 政策
	<br/><br/>通过使用Cookies，游斐向用户提供简单易行并富个性化的网络体验。一个Cookies是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。游斐使用Cookies是为了让其用户受益。比如，为使得游斐的登录过程更快捷，用户们可以选择把用户名和口令存在一个Cookies中。这样下次当用户要登录游斐的服务时，只要点击一键就可以了。Cookies能帮助我们确定您连接的页面和内容，您在游斐特定网页上花费的时间和您所选择的游斐的产品或服务。
	<br/><br/>Cookies 还能告诉我们您在我们的网页上看到了哪些广告。总之，Cookies是放置在游斐的计算机或服务器上的您的身份证。Cookies只能被设置它们的服务器阅读，而且不能执行任何代码或病毒。Cookies使得游斐能更好、更快地为您服务，并且使您在游斐网页上的经历更富个性化。然而，基于您能够控制Cookies是否以及怎样被你的浏览器接受，请查阅您的浏览器附带的文件以获得更多这方面的信息。简而言之，游斐将Cookies当作一种便捷的体验，其作用是使得用户在从游斐的一项服务转到另一项服务时，无须再证明自己的身份。
	<br/><br/>我们和第三方合作伙伴可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存。
	<br/><br/>我们使用自己的cookies和web beacon，用于以下用途：
	<br/><br/>• 记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；
	<br/><br/>• 分析您使用我们服务的情况。我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动、或哪些网页或服务最受欢迎； 
	<br/><br/>• 广告优化。Cookies和web beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。 
	<br/><br/>我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析您和其他用户如何使用我们的服务并用于广告服务。
	<br/><br/>我们的产品和服务上可能会有合作伙伴和其他合作方放置的cookies和web beacon。这些cookies和web beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web beacon收集和使用该等信息不受本《隐私政策》约束，而是受到其自身的个人信息保护声明约束，我们不对第三方的cookies或web beacon或第三方对您任何信息的收集或使用承担任何责任。
	<br/><br/>您可以通过浏览器或用户选择机制拒绝或管理cookies或web beacon。但请您注意，如果您停用cookies或web beacon，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。
	<br/><br/>六、我们服务中的第三方服务 
	<br/><br/>我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：
	<br/><br/>• 您可利用 “分享”键将某些内容分享到我们的产品或服务，或您可利用第三方连线服务登录我们的产品或服务。这些功能可能会收集您的信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；
	<br/><br/>• 我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。
	<br/><br/>该等第三方社交媒体或其他服务由相关的第三方负责运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受第三方自己的服务条款及个人信息保护声明（而非本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的用户的个人信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，对任何第三方使用由您提供的信息导致您的合法权益受损，我们并不承担任何责任。
	<br/><br/>七、未成年人保护
	<br/><br/>7.1 根据相关法律法规的规定，如果您是未满18周岁的未成年人（特别是未满十四周岁的儿童），需在监护人的陪同下阅读本《隐私政策》，并在取得监护人对本《隐私政策》全部条款的同意之后，方可使用游斐提供的产品或服务。 若您是未成年人的监护人，当您对您所监护的未成年人（特别是未满十四周岁的儿童）的个人信息有相关疑问时，可通过游斐官方公布的客服联系方式与我们联系。
	<br/><br/>7.2 若您是未满十四周岁的儿童用户，请您在您的监护人的陪同下务必仔细阅读并充分理解本《隐私政策》，在您和您的监护人确认充分理解并完全同意全部条款并在取得您的监护人对本《隐私政策》全部条款的同意之后使用游斐提供的产品或服务：
	<br/><br/>7.2.1 游斐收集儿童个人信息的条款请见本《隐私政策》第一条的约定；
	<br/><br/>7.2.2 游斐使用儿童个人信息的条款请见本《隐私政策》第二条的约定；
	<br/><br/>7.2.3 游斐分享、转让、披露、保留、储存和保护儿童个人信息的条款请见本《隐私政策》第三条的约定；
	<br/><br/>7.2.4 游斐管理、删除、注销儿童个人信息的条款请见本《隐私政策》第四条的约定；
	<br/><br/>7.2.5 游斐通过COOKIES、日志档案和WEB BEACON收集、使用儿童个人信息的条款请见本《隐私政策》第五条的约定；
	<br/><br/>7.2.6 游斐可能为儿童链接至第三方提供的社交媒体或其他服务的条款请见本《隐私政策》第六条的约定；
	<br/><br/>若您是未满十四周岁儿童的监护人，当您对您所监护的儿童使用我们的服务或其向我们提供的用户信息有任何疑问时，请您根据本《隐私政策》提供的联系方式及时与我们联系。我们将根据国家相关法律法规及本《隐私政策》的规定保护儿童用户信息的保密性及安全性。游斐设有个人信息保护专职部门并指定了专门的儿童个人信息保护负责人，将严格按照本《隐私政策》保护儿童个人信息。如监护人和儿童有关于网络信息安全的投诉和举报，或对本《隐私政策》及/或游斐对儿童个人信息保护的规则、措施的相关事宜有任何问题、意见或建议，请随时与我们联系，可发送邮件至business@yofijoy.com。
	<br/><br/>八、适用范围 
	<br/><br/>除某些特定产品或服务外，我们的产品或服务均适用本《隐私政策》。这些特定产品或服务将适用特定的个人信息保护声明。这些特定产品或服务的个人信息保护声明构成本《隐私政策》的一部分。
	<br/><br/>如特定隐私条款与本《隐私政策》条款存在同类条款约定不一致的情形，则在特定条款约束范围内以特定隐私条款为准。
	<br/><br/>请您注意，本《隐私政策》不适用于通过我们的产品或服务而接入的第三方产品或服务（包括但不限于任何第三方网站）或第三方收集的信息。
	<br/><br/>九、其他规定
	<br/><br/>9.1 如本《隐私政策》中的任何条款无论因何种原因完全或部分无效或不具有执行力，本《隐私政策》的其余条款仍应有效并且有约束力以及具有执行力。
	<br/><br/>9.2 本《隐私政策》所有条款的标题仅为方便阅读，本身并无实际涵义，不能作为本《隐私政策》及相关条款涵义解释的依据。
	<br/><br/>9.3 游斐不行使、未能及时行使或者未充分行使本协议或者按照法律法规规定所享有的权利，不应被视为放弃该权利，也不影响游斐在将来行使该等权利。
	<br/><br/>9.4 游斐保留对本《隐私政策》的修改，增补，删除、更新等有关权利。
	<br/><br/>9.5 本《隐私政策》的订立、履行、解释及争议的解决均适用中华人民共和国法律并排除其他一切冲突法的适用。本协议订立于上海市徐汇区。如双方就本《隐私政策》的内容或其执行发生任何争议（包括但不限于合同或者其他财产性权益纠纷），双方应友好协商解决；协商不成时，双方同意交由上海市徐汇区人民法院管辖并处理。
	<br/><br/>十、联系方式
	<br/><br/>如果您对本《隐私政策》或其他相关事宜有任何意见或建议，可通过游斐官方公布的客服联系方式以及以下联系方式与我们联系，我们会给予您必要的帮助：
	<br/><br/>联系邮箱：business@yofijoy.com
	<br/><br/>联系电话：021-64311803
	<br/><br/>游斐联系地址：上海市徐汇区钦州北路1198号智汇大楼82幢21层
	<br/><br/>最后，您是唯一对您的账号和密码信息负有保密责任的人。任何情况下，请您注意，小心妥善保管，若因您自身原因导致您个人信息或隐私泄露或给您造成损失或其他不利影响，游斐对此不承担任何责任。
	 
	<br/><br/>上海游斐网络科技有限公司
	<br/><br/>更新日期：2019年12月13日

	
	
	
	`,
	
}